import React from 'react'
import AdminDrawer from '../Drawers/AdminDrawer'
import Drawer from '@material-ui/core/Drawer'
import CustomerView from '../Customer/CustomerView'
import ProductView from '../Products/ProductView'
import LogisticView from '../Logistic/LogisticView'
import HhrrAdminView from '../Admin/Hhrr/HhrrAdminView'
import BillingView from '../Billing/BillingView'
import { connect } from 'react-redux';
import * as actionCreators from '../../actions/admin';
import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import DashboardAdminView from './Dashboard/DashboardAdminView'

const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };


function mapStateToProps(state) {
    return {
      status: state.admin.currentView,
      openMenu: state.drawer.openMenu,

    };
  }

  function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
  }


@connect(mapStateToProps, mapDispatchToProps)
class AdminView extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            openMenu: this.props.openMenu
        }
        this.getView = this.getView.bind(this)

    }

    getView(){
        let view = <CustomerView />
        if(this.props.status == 'Productos'){
            view = <ProductView />
        }
        else if(this.props.status == 'Logistica'){
            view = <LogisticView />;
        }
        else if(this.props.status == 'RRHH'){
            view = <HhrrAdminView/>
        }
        else if(this.props.status == 'Facturacion'){
            view = <BillingView />
        }
        else if(this.props.status == 'Dashboard'){
            view = <DashboardAdminView />
        }
        return view;
    }
    getStatus = () =>{
        return this.props.openMenu
    }
    clicked = (e) =>{
        this.props.switchMenu(false)
    }

    getDrawer = () =>{
        const view = this.getView()
        return (<div>
                <Drawer
                    anchor="left"
                    open={this.props.openMenu}
                    onClick={this.clicked}
                >
                    <AdminDrawer />

                </Drawer>
                <div className="col-md-12">

                   {view}

                </div>
            </div>
        )
    }
    render() {
        const _view = this.getDrawer()
        return _view

    }
}

export default AdminView



// WEBPACK FOOTER //
// ./src/components/Admin/AdminView.js